import { REST_API_URL } from "../constants";
import { IFileMetadataEntity } from "@odata/GeneratedEntityTypes";

export const ROSSUM_EXTRACT_URL = `${REST_API_URL}/Rossum`;
// https://developers.rossum.ai/docs/document-import-specification
const eligibleExtensions = ["pdf", "png", "jpeg", "jpg", "tiff", "xlsx", "xls", "docx", "doc"];

export const isFileRossumEligible = (fileMetadata: IFileMetadataEntity, ignoreIsdoc?: boolean): boolean => {
    return (ignoreIsdoc || !fileMetadata.IsIsdocReadable) && fileMetadata.IsRossumReadable;
};